import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const destroyAgencyAllowIp = async (
  id: string,
  ipAddress: string,
  agencyCode: string
): Promise<AxiosResponse> => {
  // dataプロパティはリクエストには必要ないが、証跡で残してもらうために送信する
  const response = await axios
    .delete(`/api/agency-ips/${id}`, {
      data: {
        ipAddress,
        agencyCode,
      },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
